import { ScheduleGridHeaderCellProps } from '@intrasync/react';

const HardwareScheduleLeftHeaderCell = (props: ScheduleGridHeaderCellProps) => {
    return (
        <div
            style={{
                border: '1px solid #eee',
                ...props.style,
                ...props.styles,
            }}
        >
            <b>Date</b>
        </div>
    );
};

export default HardwareScheduleLeftHeaderCell;